import React, {Fragment} from "react";
import logo from "./img/logomin.svg";
import {Col, Row} from "react-bootstrap";
import {getMessage} from "./util";

const version = require('../package.json');


const Footer = (props) => {

    return (
        <Fragment>

            <Row className="justify-content-center EvColorBlue pb-4 pt-4 mt-4">
                <Col xs={3} sm={1} className={"text-right"}>
                    <img className="img-max-100" src={logo} alt="footer"/>

                </Col>
                <Col xs={8} md={5} className={"text-white font-weight-bold"}>


                    <Row className={"m-5 text-left"}>
                        <Col>
                            <h5>{getMessage('footer_message', props.messages)}</h5>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <small>© E-Voting {new Date().getFullYear()}, v. {version.version}</small>
                </Col>
            </Row>
        </Fragment>
    );
}


export default Footer;
